import type { VoidFunctionComponent } from 'react';

import { QUALITY_ISSUE_TYPE_LABELS } from '../../../../../shared/issuesV2';
import { DocsLink, IconText, icons } from '../../../generic';
import type { QualityIssueType, RiskIssueType } from '../../../../../shared/issuesV2';

type Props = {
  type: RiskIssueType;
};

/**
 * Displays a little blurb and a link to the Risk Intelligence docs.
 */
const RiskDocs: VoidFunctionComponent<Props> = ({ type }) => {
  const docsLink = `/supply-chain-risk#${type.replace('risk_', '')}`;

  return (
    <div>
      For more information, see our{' '}
      <DocsLink to={docsLink} openInNewTab>
        <IconText
          text={`${QUALITY_ISSUE_TYPE_LABELS[type as QualityIssueType]} docs`}
          icon={icons.externalLink}
          alignIcon="right"
        />
      </DocsLink>
      .
    </div>
  );
};

export default RiskDocs;
